<template>
  <div class="myBacklog">
    <div>
      <div class="searchBox" v-if="$route.meta.type == 'approve'">
        <div class="search">
          <input
            type="text"
            v-model.trim="searchForm.workflowName"
            placeholder="请输入工作流名称"
          />
          <span @click="handleSearch">
            <svg-icon icon-class="search" style="cursor: pointer" />
          </span>
        </div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, index) in data" :key="index">
          <div class="title">
            {{ item.createUser }}提交的{{ item.workflowName }}
          </div>
          <div class="text">
            工作流名称：{{ item.workflowName
            }}<span>{{ item.statusName }}</span>
          </div>
          <div class="text">申请时间：{{ item.createTime }}</div>
          <div class="van-hairline--bottom fg"></div>
          <div class="btnBox noCopy">
            <van-button @click="goTo(item)">审核</van-button>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      finished: false,
      data: [],
      total: 0,
      searchForm: {
        pageNum: 1,
        pageRows: 10,
        workflowName: "",
      },
    };
  },
  methods: {
    handleSearch() {
      this.searchForm.pageRows = 10;
      this.getData(this.searchForm);
    },
    onLoad() {
      this.searchForm.pageRows += 10;
      this.getData(this.searchForm);
    },
    getData() {
      let path = "/payment/center/reimburse/getTodoList";
      if (this.$route.meta.type == "receiptApproval") {
        path = "/payment/center/reimburse/getCollectList";
      }
      this.$api
        .post(path, {
          reqData: {
            ...this.searchForm,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.list;
            this.total = res.repData.total;
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
    goTo(item) {
      let path = "";
      if (item.workflow == 0) {
        path = "/approveSq";
      }
      if (item.workflow == 1) {
        path = "/approveCc";
      }
      if (item.workflow == 2) {
        path = "/approveCity";
      }
      if (item.workflow == 3) {
        path = "/approveLx";
      }
      if (item.workflowName == 4) {
        path = "/approveCb";
      }
      if (item.workflow == 5) {
        path = "/bx5approve";
      }
      if (item.workflow == 6) {
        path = "/bx6approve";
      }
      if (item.workflow == 7) {
        path = "/bx7approve";
      }
      if (item.workflow == 8) {
        path = "/bx8approve";
      }
      if (item.workflow == 9) {
        path = "/bx9detail";
      }
      if (item.workflow == 10) {
        path = "/bx10detail";
      }
      if (item.workflow == 11) {
        path = "/bx11detail";
      }
      if (item.workflow == 12) {
        path = "/bx12detail";
      }
      if (item.workflow == 13) {
        path = "/bx13detail";
      }
      this.$router.push({
        path: path,
        query: {
          id: item.id,
          type: "approve",
          approveType: this.$route.meta.type,
        },
        name:path.split("/")[1],
        params:{
          fristEnter:true
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.myBacklog {
  height: 100%;
  padding: 0 16px 10px;
  .searchBox {
    padding: 10px 0;
    // background: #fff;
    .search {
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      input {
        flex: 1;
        outline: none;
        border: none;
        background: rgba($color: #000000, $alpha: 0);
      }
    }
  }
  .item {
    width: 100%;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 10px 20px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 22px;
    .title {
      color: rgb(75, 76, 75);
      margin-top: 4px;
    }
    .fg {
      margin-top: 4px;
    }
    .text {
      display: flex;
      justify-content: space-between;
      span {
        width: 76px;
        text-align: center;
      }
    }
    .btnBox {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      button {
        width: 76px;
        height: 24px;
        border-radius: 30px;
        color: rgb(75, 76, 75);
        font-size: 12px;
      }
    }
  }
}
</style>